import ShopLayout from "../../components/signup/shop-layout";
import { useLocation } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../../components/auth-context";
import useAppNavigate from "../../components/router/use-app-navigate";
import CustomerInfo, {
  ICustomerData,
} from "../../components/signup/customer-info";

export default function ShopSignUp() {
  const location = useLocation();
  const { type } = location.state || {};
  const context = useContext(AuthContext);
  const navigate = useAppNavigate();
  const handleAgentDataChange = () => {};
  function onCustomerInfoSubmit(data: ICustomerData) {
    context.setCustomerData(data);
    navigate(`/shop/uploadImage`);
    navigate("/shop/uploadImage", {
      state: {
        isShop: true,
      },
    });
  }
  const { cellPhone } = location.state || {};

  return (
    <ShopLayout
      type={Number(type)}
      step={Number(type) === 40 ? 6 : 5}
      steps={Number(type) === 40 ? [5, 6, 7] : [4, 5, 6]}
    >
      <CustomerInfo
        defaultCellPhone={cellPhone!}
        isShop={true}
        handleAgentDataChange={handleAgentDataChange}
        onSubmit={onCustomerInfoSubmit}
      />
    </ShopLayout>
  );
}
